var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-view-sheet-field',{attrs:{"align":"center","is-sticky":_vm.isSticky,"field":_vm.field,"filter":_vm.filter}},[_c('core-date',{attrs:{"date":_vm.value,"is-plain":true,"invalid":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }